import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=aff9b1d6&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=aff9b1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff9b1d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aff9b1d6')) {
      api.createRecord('aff9b1d6', component.options)
    } else {
      api.reload('aff9b1d6', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=aff9b1d6&scoped=true&", function () {
      api.rerender('aff9b1d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23Q6IZHfpWu1g/JS/comp/PopupBox.vue"
export default component.exports